import { fork } from 'redux-saga/effects';
// Sagas
import stepper from './stepper';
import verificacion from './verificacion';
import casoBorde from './casoBorde';
import paises from './paises';
import parametros from './parametros';
import oferta from './oferta';
import sucursal from './sucursal';
import contratos from './contratos';
import encuesta from './encuesta';

// General forking sagas.
export default function* rootSaga() {
  yield fork(stepper);
  yield fork(verificacion);
  yield fork(casoBorde);
  yield fork(paises);
  yield fork(parametros);
  yield fork(contratos);
  yield fork(oferta);
  yield fork(sucursal);
  yield fork(encuesta);
}
